import { ButtonNew, Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'
import { FC } from 'react'

/* Used to show error or success messages */
const InfoMessage: FC<{
    subject: string[]
    description?: string
    onClose: () => void
}> = ({ subject, description, onClose }) => {
    return (
        <>
            <Text variant="body1" sx={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
                {description}
            </Text>
            <Box>
                {subject.map((e, i) => (
                    <Text
                        key={i}
                        variant={'h5'}
                        sx={{
                            textAlign: 'center',
                        }}
                    >
                        {e}
                    </Text>
                ))}
            </Box>
            <ButtonNew onClick={onClose}>OK</ButtonNew>
        </>
    )
}

export default InfoMessage
